module.exports = __webpack_public_path__ + "media/images/icons/ic-help-5f905011b78b172e54c510694d57df19.svg";